export default __webpack_public_path__ + "static/media/Manit01.74e06711.png";